import { Component, OnInit } from '@angular/core';
import { RicercaElementiService } from './ricerca-elementi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-ricerca-elementi',
  templateUrl: './ricerca-elementi.component.html',
  styleUrls: ['./ricerca-elementi.component.scss'],
  providers:[RicercaElementiService]
})
export class RicercaElementiComponent implements OnInit {
  
  websiteUrl = `${environment.apiEndpoint}/docs/documenti_pdf/`;
  sanitizedCorpo(articolo): any {
    return this._sanitizer.bypassSecurityTrustHtml(articolo.corpo);
    
  }
  sezioneById: { [typeId: number]: { title: string} } = {
    1:  { title: 'RAPPORTI DI EVENTO' },
    2:  { title: 'ORDINAMENTO E NORMATIVA' },
    3:  { title: 'MONOGRAFIE' },
    4:  { title: 'ELABORAZIONI CLIMATICHE' },
    5:  { title: 'ALTRO'},
  };
  categoriaById: { [typeId: number]: { title: string} } = {
    1:  { title: 'Rapporti di evento meteo-idrogeologici' },
    2:  { title: 'Report' },
    3:  { title: 'Poster' },
    4:  { title: 'Opuscoli' },
    5:  { title: 'Schede'},
    6:  { title: 'Generali' },
    7:  { title: 'Sistema di allertamento' },
    8:  { title: 'Monografie' },
    9:  { title: 'Rete dei Centri Funzionali'},
    10: { title: 'Normativa statale' },
    11: { title: 'Leggi regionali' },
    12: { title: 'Assetto organizzativo' }
  };


  imageOptions = [
    { id: 1, title: 'Default', src: 'assets/images/placeholder_news_default.webp' },
    { id: 2, title: 'Bollettino', src: 'assets/images/placeholder_bollettino.webp' },
    { id: 3, title: 'Avviso', src: 'assets/images/placeholder_avviso.webp' }
  ];
  statoCaricamento = 0;
  ricerca = "";
  ricercaDocs = "";
  resultList: any[] = []; // qui salviamo i risultati
  resultListDocs: any[] = []; // qui salviamo i risultati
  loading: boolean = false;
  error: boolean = false;
  totaleRisultatiNews = 0;
  totaleRisultatiDocs = 0;


  constructor(
    private route: ActivatedRoute,
        public restService: RicercaElementiService,
        private modalService: NewModalService,
        private _sanitizer: DomSanitizer,
        private router: Router
  ) {
    this.route.queryParams.subscribe(params => {
      if (params['find']) {
        this.ricerca = params['find'];
        this.filterNews(); // deve esserci
      } else {

      }
    });
    
   }
   findById(idArticolo: number) {
    this.router.navigate(['/news', idArticolo]);
  }
  linkToDoc(url: string): void {
    const finalUrl = `${this.websiteUrl}${url}`;
    window.open(finalUrl, 'Documento', 'left=20,top=20,width=800,height=700,toolbar=0,resizable=1');
  }

  ngOnInit(): void {
    this.filterNews(); // deve esserci
    this.filterDocs(); // deve esserci
  }
  getImageSrcById(id: number): string {
    const found = this.imageOptions.find(opt => opt.id === id);
    return found ? found.src : 'assets/images/placeholder_news_default.webp';
  }
  getAnteprimaTesto(corpoHtml: string, maxLength: number =  350 ): string {
    if (!corpoHtml) return '';  
  
    const plainText = corpoHtml
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/?[^>]+(>|$)/g, '')  // rimuove tutti i tag HTML
  
      .replace(/\s\s+/g, ' ')
      .trim();
  
    return plainText.length > maxLength
      ? plainText.slice(0, maxLength).trim() + '...'
      : plainText;
  }
  filterNews(): void {
    this.loading = true;
    this.error = false;
    
    //console.log("filterNews chiamato");
    this.restService.filterNews(this.ricerca , 1)
      .then(res => {
        this.loading = false;
        this.resultList = res?.articoliBindList || res || [];
        //console.log("Termine di ricerca ricevuto:", this.ricerca);
        this.statoCaricamento ++;
        this.totaleRisultatiNews = res.totArticoli;
        
      })
      .catch(err => {
        this.loading = false;
        this.error = true;
        //console.error('Errore durante la ricerca:', err);
      });
  }
  moreNews(): void {
    this.loading = true;
    this.error = false;

    console.log("More news chiamato");
    this.restService.filterNews(this.ricerca, this.statoCaricamento)
      .then(res => {
        this.loading = false;
        this.resultList.push(...res.articoliBindList)
        
        this.statoCaricamento ++;
      })
      .catch(err => {
        this.loading = false;
        this.error = true;
        console.error('Errore durante la ricerca:', err);
      });
  }

  filterDocs(): void {
    this.loading = true;
    this.error = false;
    
    //console.log("filterNews chiamato");
    this.restService.filterDocs(this.ricerca , 1)
      .then(res => {
        this.loading = false;
        this.resultListDocs = res?.documentiBindList || res || [];
        //console.log("Termine di ricerca ricevuto:", this.ricerca);
        this.statoCaricamento ++;
        this.totaleRisultatiDocs = res.totDocumenti;
        
      })
      .catch(err => {
        this.loading = false;
        this.error = true;
        //console.error('Errore durante la ricerca:', err);
      });
  }
  moreDocs(): void {
    this.loading = true;
    this.error = false;

    console.log("More docs chiamato");
    this.restService.filterDocs(this.ricerca, this.statoCaricamento)
      .then(res => {
        this.loading = false;
        this.resultListDocs.push(...res.documentiBindList)
        
        this.statoCaricamento ++;
      })
      .catch(err => {
        this.loading = false;
        this.error = true;
        console.error('Errore durante la ricerca:', err);
      });
  }
}
